if (jcms.communitiesMap && $('#map').length && typeof mapSettings != 'undefined') {

  var corporateMap = {
    dom: function() {
      this.$canvas = $('#map');
      this.$infoboxTemplate = $('#infobox-template');
    },

    definitions: function() {
      this.carousel;
      this.instance;
      this.googleMaps;
      this.categories;
      this.properties;
      this.mapCenter;
      this.mapBounds;
      this.openInfobox;
      this.markers = [];
      this.infoboxHTML = corporateMap.$infoboxTemplate.html().replace(/  /g, '').replace(/\n/g, '');
      this.$propertyCards = $('#properties .communities__item');
      this.$communityCards = $('#communityCards');
      this.icon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="{{ color }}"><path d="M8,0C3.8,0,0,3.4,0,7.6S3.47,16.81,8,24c4.53-7.19,8-12.2,8-16.4S12.2,0,8,0ZM8,11a3,3,0,1,1,3-3A3,3,0,0,1,8,11Z"/></svg>';
    },

    options: {
      zoom: mapSettings.defaultMapZoom,
      minZoom: 3,
      maxZoom: 16,
      // scrollwheel: false,
      center: { lat: mapSettings.lat, lng: mapSettings.lng },
      mapTypeId: mapSettings.mapTypeId,
      // fullscreenControl: false,
      mapTypeControl: mapSettings.mapTypeControl,
      mapTypeControlOptions: {
        mapTypeIds: mapSettings.mapTypeIds
      },
      streetViewControl: mapSettings.showStreetview,
      styles: mapSettings.styles ? mapSettings.styles : [
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": (mapSettings.colorText ? mapSettings.colorText : "#727272")
          }]
        },{
          "featureType": "administrative",
          "elementType": "all",
          "stylers": [{
            "visibility": (mapSettings.showReservations ? "on" : "off")
          }]
        }, {
          "featureType": "administrative.country",
          "elementType": "all",
          "stylers": [{
            "visibility": "on"
          }]
        }, {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [{
            "visibility": "on"
          }]
        }, {
          "featureType": "administrative.locality",
          "elementType": "all",
          "stylers": [{
            "visibility": "on"
          }]
        }, {
          "featureType": "administrative.neighborhood",
          "elementType": "all",
          "stylers": [{
            "visibility": (mapSettings.showNeighborhoods ? "on" : "off")
          }]
        }, {
          "featureType": "administrative.land_parcel",
          "elementType": "all",
          "stylers": [{
            "visibility": "on"
          }]
        }, {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorGround ? mapSettings.colorGround : "#efefef")
          }]
        }, {
          "featureType": "landscape.man_made",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorTerrain ? mapSettings.colorTerrain : "#d7ecc4")
          }]
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [{
            "visibility": (mapSettings.showPois ? "on" : "off")
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "all",
          "stylers": [{
            "visibility": (mapSettings.showParks ? "on" : "off")
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorPark ? mapSettings.colorPark : "#c1e4c3")
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorRoad ? mapSettings.colorRoad : "#dfdcdb")
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": (mapSettings.colorRoadStroke ? mapSettings.colorRoadStroke : "#cccccc")
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorHighway ? mapSettings.colorHighway : "#dfdcdb")
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": (mapSettings.colorHighwayStroke ? mapSettings.colorHighwayStroke : "#c2bebc")
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": (mapSettings.colorWater ? mapSettings.colorWater : "#b6cce4")
          }]
        }]
    },

    infoboxOptions: {},

    getMarkerData: function() {
      corporateMap.categories = mapSettings.property_types;
      corporateMap.properties = mapSettings.properties;
    },

    loadMap: function() {
      corporateMap.googleMaps = google.maps;
      corporateMap.instance = new corporateMap.googleMaps.Map(corporateMap.$canvas[0], corporateMap.options);

      corporateMap.infoboxOptions = {
        content: null, // -- Set by drawPoint
        disableAutoPan: false,
        alignBottom: true,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-130, -46),
        zIndex: null,
        boxClass: "communities__map-infobox",
        infoBoxClearance: new google.maps.Size(10, 10),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: true,
        closeBoxURL: ''
      };

      // Add map controls
      corporateMap.addControls();
      // Add event listeners
      corporateMap.addListeners();
      // Add properties to map
      corporateMap.loadMarkers();
      // Set marker visibility
      corporateMap.markerVisibility(null, mapSettings.fitBounds, false, true);
    },

    addControls: function() {
      // console.log(corporateMap.googleMaps, corporateMap.instance);
    },

    addListeners: function() {
      var self = this;

      corporateMap.googleMaps.event.addListenerOnce(corporateMap.instance, 'idle', function(){
        // WCAG fixes
        setTimeout(function() {
          self.$canvas.find('img').each(function(index) {
            if (!$(this).attr('alt')) {
              $(this).attr('alt','Google Maps Icon ' + index);
            }
          });
          $('iframe', self.$canvas).removeAttr('frameborder').attr('title', 'Google Maps iframe');
        }, 1500);

        // Set options based on screen size
        corporateMap.optionChanges();
      });

      corporateMap.googleMaps.event.addListener(corporateMap.instance, 'bounds_changed', function(){
        // Set options based on screen size
        corporateMap.optionChanges();
      });

      // clear "Focused" states
      corporateMap.googleMaps.event.addListener(corporateMap.instance, 'click', function() {
        if (corporateMap.openInfobox) {
          corporateMap.openInfobox.close();
        }
        corporateMap.removeFocused();
      });
    },

    optionChanges: function() {
      if (window.innerWidth > jcms.breakpoints.fluid) {
        corporateMap.instance.setOptions({
          disableDefaultUI: false
        });
      }
      else {
        corporateMap.instance.setOptions({
          disableDefaultUI: true
        });
      }
    },

    focusMarker: function(id) {
      if (id) {
        id = parseInt(id, 10);
        if (corporateMap.markers.length) {
          corporateMap.markers.forEach(function(marker) {
            if (marker.id === id) {
              marker.setIcon(marker.icon_alt);
            }
            else {
              if (!marker.active) {
                marker.setIcon(marker.icon_reg);
              }
            }
          });
        }
      }
    },

    unfocusMarker: function(id) {
      if (id) {
        corporateMap.markers.forEach(function(marker) {
          if (marker.id === id && !marker.active) {
            marker.setIcon(marker.icon_reg);
          }
        });
      }
    },

    removeFocused: function() {
      corporateMap.markers.forEach(function(tempMarker) {
        tempMarker.active = false;
        tempMarker.setIcon(tempMarker.icon_reg);
      });
    },

    loadMarkers: function() {
      $.each(corporateMap.properties, function(index, property) {
        if (!property.active && !jcms.devmode) { return; }

        var infoboxHTML = corporateMap.infoboxHTML;
        var latlng = new corporateMap.googleMaps.LatLng(property.lat, property.lng);

        // set marker icon and color
        var color = jcms.colors.accent;
        if (typeof property.color != 'undefined' && property.color.length) {
          color = property.color;
        }
        var icon = corporateMap.icon.replace('{{ color }}', color);
        var icon_regular = {
          url: 'data:image/svg+xml;charset=UTF8,' + encodeURIComponent(icon),
          scaledSize: new google.maps.Size(16,24)
        };

        var icon_large = {
          url: 'data:image/svg+xml;charset=UTF8,' + encodeURIComponent(icon),
          scaledSize: new google.maps.Size(24,36)
        };

        // add marker to map
        var marker = new corporateMap.googleMaps.Marker({
          position: latlng,
          data: property,
          map: corporateMap.instance,
          title: property.name,
          icon: icon_regular
        });

        // add marker to markers array (used for filtering)
        corporateMap.markers.push($.extend(marker, {
          category: property.property_type ? property.property_type.slug : false,
          id: property.id,
          active: false,
          icon_reg: icon_regular,
          icon_alt: icon_large
        }));

        // -- Build map infobox's
        // check for any "{{if}}" mustache code
        var matches, replacement, condition;
        var mustacheRegex = /{{if (.*?)}}(.*?){{endif}}/i;
        // loop until no more mustache "if's" found
        while ((matches = mustacheRegex.exec(infoboxHTML)) !== null) {
          replacement = '';
          condition = matches[1].trim();
          // check if condition contains a period
          if (condition.indexOf('.') !== -1) {
            condition = condition.split('.')[0];
          }
          // check if else is used
          if (matches[2] && matches[2].indexOf('{{else}}') !== -1) {
            var split = matches[2].split('{{else}}');
            if (property[condition]) {
              replacement = split[0];
            }
            else {
              replacement = split[1];
            }
          }
          else {
            if (property[condition]) {
              replacement = matches[2];
            }
          }
          // replace code
          infoboxHTML = infoboxHTML.replace(matches[0], replacement);
        }

        // -- Mustache Replacement
        for (var field in property) {
          if (field) {
            var expression;
            if (typeof property[field] === 'object') {
              for (var variable in property[field]) {
                if (variable.length) {
                  expression = new RegExp('({{' + field + '\.' + variable + '}})', 'g');
                  if (infoboxHTML.match(expression)) {
                    infoboxHTML = infoboxHTML.replace(expression, property[field][variable]);
                  }
                }
              }
            }
            else {
              expression = new RegExp('({{' + field + '}})', 'g');
              if (infoboxHTML.match(expression)) {
                infoboxHTML = infoboxHTML.replace(expression, property[field]);
              }
            }
          }
        }

        var infobox = new InfoBox($.extend(corporateMap.infoboxOptions, {content: infoboxHTML}));

        // add mouseover listener to marker
        corporateMap.googleMaps.event.addListener(marker, 'mouseover', function() {
          marker.setIcon(marker.icon_alt);
        });

        // add mouseout listener to marker
        corporateMap.googleMaps.event.addListener(marker, 'mouseout', function() {
          if (!marker.active) {
            marker.setIcon(marker.icon_reg);
          }
        });

        // add click listener to marker
        corporateMap.googleMaps.event.addListener(marker, 'click', function() {
          var cardPosition, cardOffset, swiper, $card;
          var offset = window.innerWidth <= jcms.breakpoints.fluid ? 20 : 40;
          // remove focused states
          corporateMap.removeFocused();
          // set focused states
          marker.active = true;
          marker.setIcon(icon_large);
          // close all infoboxes
          if (corporateMap.openInfobox) {
            corporateMap.openInfobox.close();
          }
          if (corporateMap.$communityCards.is(':visible')) {
            cardPosition = corporateMap.$communityCards.find('[data-property="' + marker.id + '"]').index();
            swiper = corporateMap.$communityCards[0].swiper;
            swiper.slideTo(cardPosition);
          }
          else {
            $card = corporateMap.$propertyCards.filter('[data-property="' + marker.id + '"]');
            cardOffset = $card.position().top;
            corporateMap.$propertyCards.removeClass('hover');
            $card.addClass('hover');
            $card.parent().animate({
              scrollTop: cardOffset
            });
            infobox.open(corporateMap.instance, marker);
            corporateMap.openInfobox = infobox;
          }
        });
      });
    },

    markerVisibility: function(ids, resize, recenter, reset) {
      var boundry = new corporateMap.googleMaps.LatLngBounds();

      // close any open infoboxes
      if (corporateMap.openInfobox) {
        corporateMap.openInfobox.close();
      }

      corporateMap.markers.forEach(function(marker) {
        if (!reset) {
          marker.setVisible(false);
        }

        if (typeof ids == 'undefined' || (ids && ids.indexOf(marker.id) != -1) || reset) {
          boundry.extend(marker.position);
          marker.setVisible(true);
        }
      });

      if (resize) {
        corporateMap.instance.fitBounds(boundry);
      }
      else if (recenter) {
        corporateMap.instance.setCenter(boundry.getCenter());
      }
      else {
        corporateMap.instance.fitBounds(boundry);
      }
    },

    fixFont: function() {
      var head = document.getElementsByTagName( 'head' )[0];
      // Save the original method
      var insertBefore = head.insertBefore;
      // Replace it!
      head.insertBefore = function( newElement, referenceElement ) {
        if ( newElement.href && newElement.href.indexOf( 'https://fonts.googleapis.com/css?family=Roboto' ) === 0 ) {
          return;
        }
        insertBefore.call( head, newElement, referenceElement );
      };
    },

    removeMap: function() {
      corporateMap.$canvas.html('<p style="padding:10px">Could not load google map.</p>');
      setTimeout(function() {
        corporateMap.$canvas.remove();
        $('.has-map').removeClass('has-map').addClass('no-map');
      }, 1000);
    },

    checkData: function() {
      let loopNum = 0;
      // -- Keep on looping until the google maps script is loaded
      const mapLoaded = setInterval(function() {
        loopNum++;
        if (!jcms.hidethirdparty && typeof corporateMap.properties === 'object' && typeof google === 'object' && typeof google.maps === 'object' && loopNum <= 20) {
          clearInterval(mapLoaded);
          corporateMap.loadMap();
          corporateMap.fixFont();
        }
        else {
          clearInterval(mapLoaded);
          corporateMap.removeMap();
          return false;
        }
      }, 500);
    },

    ready: function() {
      corporateMap.dom();
      corporateMap.definitions();
      corporateMap.getMarkerData();
      corporateMap.checkData();
    }
  };

  $(window).on('load', corporateMap.ready);

}
